import { useDasBalanceContext } from '@did/das-app-context'
import { CYCLE_CALL_FUNCTION_TIME } from '@did/constants'
import { UseDidPointBalance } from '@did/das-balance-types'
import { useEffect, useState } from 'react'

export const useDidPointBalance: UseDidPointBalance = () => {
  const { services, connectedAccount } = useDasBalanceContext()
  const [balance, setBalance] = useState('0')

  const fetchBalance = async () => {
    if (!connectedAccount) return
    const balanceInfo = await services.didPoint.didPointBalance({
      key_info: {
        coin_type: connectedAccount.chain?.coinType,
        key: connectedAccount.address
      }
    })
    setBalance(balanceInfo.balance)
  }

  useEffect(() => {
    if (!connectedAccount?.address) {
      return
    }
    fetchBalance()

    const timerId = setInterval(() => {
      fetchBalance()
    }, CYCLE_CALL_FUNCTION_TIME * 3)
    return () => {
      clearInterval(timerId)
    }
  }, [connectedAccount])

  return {
    balance,
    fetchBalance
  }
}
